import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { url } from 'configs/';
const baseUrl = url.API_SERVER;
const path = 'tube/banner/';
const FETCH_BANNERS = `${path}FETCH_BANNERS`;
const FETCH_CAROUSEL_SECOND = `${path}FETCH_CAROUSEL_SECOND`;

const initialState = {
  data: [],
  isLoading: true,
  isLoaded: true,
  carouselSecond: 10,
};

export default typeToReducer({
  [FETCH_BANNERS]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, { isLoading: true, isLoaded: false, data: [] });
    },
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: true, data: action.payload.data });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: false, data: [] });
    },
  },
  [FETCH_CAROUSEL_SECOND]: {
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, { carouselSecond: action.payload.data });
    },
  },
}, initialState);

export function fetchBanners() {
  return {
    type: FETCH_BANNERS,
    payload: axios.get(`${baseUrl}company/Tube_Banner/GetOn`, {
      params: {
        language: 'zh-tw',
        bannerType: 'Tube',
      },
    }),
  };
}

export function fetchCarouselSecond() {
  return {
    type: FETCH_CAROUSEL_SECOND,
    payload: axios.get(`${baseUrl}company/COMP_CompanySetting/GetCarouselSeconds`),
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/reducers/bannerReducer.js
 **/